import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { AlertCircle, Moon, Zap, Brain, Heart } from 'lucide-react';
export function SymptomSection() {
  const symptoms = [{
    icon: <Moon className="w-6 h-6 text-[#1A6B5A]" data-id="element-195" />,
    title: 'Despertares 2–4am',
    description: 'Te despertás de golpe, con el corazón acelerado y la mente activa, sin poder volver a dormir.'
  }, {
    icon: <Heart className="w-6 h-6 text-[#1A6B5A]" data-id="element-196" />,
    title: 'Palpitaciones repentinas',
    description: 'Sentís que el corazón late fuerte sin haber hecho ejercicio, a veces estando quieta.'
  }, {
    icon: <Zap className="w-6 h-6 text-[#1A6B5A]" data-id="element-197" />,
    title: 'Irritabilidad sorpresa',
    description: "Reacciones exageradas que te sorprenden a vos misma. Sentís que estás 'por explotar'."
  }, {
    icon: <Brain className="w-6 h-6 text-[#1A6B5A]" data-id="element-198" />,
    title: 'Niebla mental',
    description: 'Te cuesta concentrarte, te olvidás de palabras simples o sentís la cabeza pesada.'
  }];
  return <section className="py-24 px-4 bg-white" data-id="element-199">
      <div className="max-w-4xl mx-auto" data-id="element-200">
        <FadeIn className="text-center mb-16" data-id="element-201">
          <h2 className="text-4xl md:text-5xl text-[#2D2A26] mb-6" data-id="element-202">
            No estás rota. <br data-id="element-203" />
            <span className="text-[#C4785B]" data-id="element-204">Estás desregulada.</span>
          </h2>
          <p className="text-xl text-[#6B6560] leading-relaxed max-w-2xl mx-auto" data-id="element-205">
            Si sos mujer 30+ y en el último tiempo te empezó una ansiedad
            “rara”… no una preocupación normal, sino una alarma corporal.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-206">
          {symptoms.map((symptom, index) => <FadeIn key={index} delay={index * 0.1} className="bg-[#FDF8F3] p-8 rounded-xl border border-[#E8DED5] hover:border-[#1A6B5A]/30 transition-colors" data-id="element-207">
              <div className="bg-white w-12 h-12 rounded-full flex items-center justify-center mb-4 shadow-sm" data-id="element-208">
                {symptom.icon}
              </div>
              <h3 className="text-xl font-bold text-[#2D2A26] mb-2 font-serif" data-id="element-209">
                {symptom.title}
              </h3>
              <p className="text-[#6B6560] leading-relaxed" data-id="element-210">
                {symptom.description}
              </p>
            </FadeIn>)}
        </div>

        <FadeIn className="bg-[#1A6B5A]/5 p-8 md:p-10 rounded-2xl border border-[#1A6B5A]/10 text-center" data-id="element-211">
          <div className="flex justify-center mb-4" data-id="element-212">
            <AlertCircle className="w-8 h-8 text-[#1A6B5A]" data-id="element-213" />
          </div>
          <h3 className="text-2xl font-serif text-[#1A6B5A] mb-4" data-id="element-214">
            Esto no es un defecto tuyo
          </h3>
          <p className="text-lg text-[#2D2A26] leading-relaxed max-w-2xl mx-auto" data-id="element-215">
            Muchas veces es una mezcla silenciosa: sueño + estrés + cambios
            hormonales + hábitos que sin querer te disparan. Y mientras intentás
            resolverlo “con la cabeza”… tu cuerpo sigue gritando.
          </p>
        </FadeIn>
      </div>
    </section>;
}